import { ReactComponent as BackofficeIcon } from 'assets/@efz/icons/backoffice.svg';
import { ReactComponent as ProcessesIcon } from 'assets/@efz/icons/processes.svg';
import { ReactComponent as BackofficeSidebarIcon } from 'assets/@efz/icons/sidebar/backoffice.svg';
import { ReactComponent as ProcessesSidebarIcon } from 'assets/@efz/icons/sidebar/processes.svg';
import { ReactComponent as ProductsSidebarIcon } from 'assets/@efz/icons/sidebar/products.svg';
import { ReactComponent as SolutionIcon } from 'assets/@efz/icons/solutions.svg';

import { TSidebarEntry } from 'types/sidebar';

import { BASENAME_URL_OPPORTUNITIES, BASENAME_URL_PROCESSES, BASENAME_URL_USERS } from './settings';

export const SIDEBAR_BUTTONS = {
    OPEN_SIDEBAR: 'openSidebar',
    OPPORTUNITIES: 'opportunities',
    PROCESSES: 'processes',
    USER_MANAGEMENT: 'userManagement',
};

export enum SIDEBAR_BUTTONS_SECTIONS {
    PROPOSALS = 'proposals',
    SITE_SURVEY = 'siteSurvey',
    ASSET_MANAGEMENT = 'assetManagement',
}

export enum SIDEBAR_ENTRIES {
    PRODUCTS = 'products',
    PROCESSES = 'processes',
    USER_MANAGEMENT = 'userManagement',
}

export const SIDEBAR_BUTTONS_CONFIG = {
    DEFAULT: [
        {
            name: SIDEBAR_BUTTONS.OPPORTUNITIES,
            label: 'sidebar.opportunities',
            icon: <SolutionIcon />,
            disabled: function () {
                return false;
            },
            navigationLabel: () => BASENAME_URL_OPPORTUNITIES,
            visible: true,
            canBeAccessed: () => true,
        },
        {
            name: SIDEBAR_BUTTONS.PROCESSES,
            label: 'sidebar.processes',
            icon: <ProcessesIcon />,
            disabled: function () {
                return false;
            },
            navigationLabel: () => BASENAME_URL_PROCESSES,
            visible: () => true,
            canBeAccessed: () => true,
        },
        {
            name: SIDEBAR_BUTTONS.USER_MANAGEMENT,
            label: 'sidebar.userManagement',
            icon: <BackofficeIcon />,
            disabled: function (hasSolutionsButton = false) {
                return !hasSolutionsButton;
            },
            navigationLabel: () => BASENAME_URL_USERS,
            visible: () => true,
            canBeAccessed: () => true,
        },
    ],
};

export const SIDEBAR_ENTRIES_CONFIG: TSidebarEntry[] = [
    {
        name: SIDEBAR_ENTRIES.PRODUCTS,
        label: 'sidebar.opportunities',
        icon: <ProductsSidebarIcon width={15} height={15} />,
        route: BASENAME_URL_OPPORTUNITIES,
        visible: true,
        expandable: false,
        dataTestId: 'efz-btn-sidebar-opportunities',
    },
    {
        name: SIDEBAR_ENTRIES.PROCESSES,
        label: 'sidebar.processes',
        icon: <ProcessesSidebarIcon width={15} height={15} />,
        route: BASENAME_URL_PROCESSES,
        visible: true,
        expandable: false,
        dataTestId: 'efz-btn-sidebar-processes',
    },
    {
        name: SIDEBAR_ENTRIES.USER_MANAGEMENT,
        label: 'sidebar.userManagement',
        icon: <BackofficeSidebarIcon width={15} height={15} />,
        route: BASENAME_URL_USERS,
        visible: true,
        expandable: false,
        dataTestId: 'efz-btn-sidebar-users',
    },
];
